import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { IProductDataV3 } from '@df/catalog/product/product';
import { Logger } from '@df/core/service/logger';
import { Ab } from '@df/module-ab/ab.namespace';
import { AbService } from '@df/module-ab/ab.service';
import { RatingComponent } from '../../../../../ui/common/rating.component';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { UiComponent } from '@df/ui/ui.component';
import { Subscription } from 'rxjs/internal/Subscription';
import { ProductDecorator } from '../../../../model/product/product.decorator';
import { ProductReviewsComponent } from '../../../review/product-reviews.component';
import { IParentView } from '../layout/product-view-layout.abstract';

@Component({
    selector: 'product-view-reviews',
    templateUrl: './product-view-reviews.component.html',
    standalone: true,
    imports: [CommonModule, ProductReviewsComponent, RatingComponent, SizeClassDirective, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductViewReviewsComponent extends UiComponent implements OnInit, OnDestroy {
    @Input()
    product: ProductDecorator<IProductDataV3>;

    @Input()
    parent: ProductDecorator<IProductDataV3>;

    @Input()
    parentView: IParentView;

    @Input()
    top = false;

    protected abService = inject(AbService);
    protected logger = inject(Logger);

    protected abServiceSubscription?: Subscription;
    public canShow = false;

    override ngOnChanges(changes: SimpleChanges): void {
        if (changes['product']) {
            this.abServiceSubscription?.unsubscribe();

            this.abServiceSubscription = this.abService.getSubject('productReviews').subscribe(value => {
                this.update(value.variant);

                this.detectChanges();
            });

            if (!this.abService.isRunning('productReviews')) {
                this.update();
            } else {
                this.logger.info('AB test for productReviews');
            }
        }

        super.ngOnChanges(changes);
    }

    override ngOnDestroy(): void {
        this.abServiceSubscription?.unsubscribe();

        super.ngOnDestroy();
    }

    protected update(variant: Ab.TVariant = 'A'): void {
        if (this.parent?.data?.reviews?.count) {
            if (this.top) {
                const canShow = !this.product.label || this.client.isS || this.client.isM;
                // display at the top
                if (variant === 'A') {
                    this.canShow = this.parentView?.productView?.showExternal && canShow;
                } else if (variant === 'B') {
                    this.canShow = canShow;
                }
            } else {
                // display at the bottom
                if (variant === 'A') {
                    this.canShow =
                        !this.parentView?.productView?.showExternal || (this.parentView?.productView?.showExternal && !!this.product.label);
                } else if (variant === 'B') {
                    this.canShow = !!this.product.label && (this.client.isL || this.client.isX);
                }
            }
        } else {
            this.canShow = false;
        }
        this.detectChanges();
    }
}
